import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-enotification-redirect',
  template: '',
  standalone: false
})
export class ENotificationRedirectComponent implements OnInit {

  ngOnInit(): void {
    globalThis.location.href = environment.ssoBase + '/myprofile/homeowner-alerts';
  }
}
